import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const GameContext = createContext();

export function GameProvider({ children }) {
  const [usedQuestions, setUsedQuestions] = useState({});
  
  const markQuestionAsUsed = useCallback((subcategory, questionId) => {
    setUsedQuestions(prev => ({
      ...prev,
      [subcategory]: [...(prev[subcategory] || []), questionId]
    }));
  }, []);
  
  const getUsedQuestions = useCallback((subcategory) => {
    return usedQuestions[subcategory] || [];
  }, [usedQuestions]);
  
  const resetSubcategory = useCallback((subcategory) => {
    setUsedQuestions(prev => ({
      ...prev,
      [subcategory]: []
    }));
  }, []);
  
  const resetAllQuestions = useCallback(() => {
    setUsedQuestions({});
  }, []);
  
  const contextValue = useMemo(() => ({
    markQuestionAsUsed,
    getUsedQuestions,
    resetSubcategory,
    resetAllQuestions
  }), [markQuestionAsUsed, getUsedQuestions, resetSubcategory, resetAllQuestions]);
  
  return (
    <GameContext.Provider value={contextValue}>
      {children}
    </GameContext.Provider>
  );
}

export function useGame() {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
} 